import React, { useEffect, useState } from "react";
import axios from "axios";
import GlassCard from "../../components/ui-custom/GlassCard";
import Reveal from "../../components/ui-custom/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    axios.get(`${API}/portal/projects`, { withCredentials: true }).then((res) => setProjects(res.data)).catch(() => {});
  }, []);

  return (
    <div className="grid gap-5">
      {projects.map((p, i) => (
        <Reveal key={p.id} delay={i * 0.06}>
          <GlassCard className="p-6">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
              <div>
                <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">{p.id}</p>
                <h3 className="font-display font-semibold text-foreground text-base">{p.name}</h3>
              </div>
              <span className="text-xs px-3 py-1 rounded-full border border-qcyan/30 text-qcyan uppercase tracking-wide">
                {p.stage}
              </span>
            </div>
            <div className="w-full h-2 rounded-full bg-white/5 overflow-hidden">
              <div
                className="h-full rounded-full bg-gradient-to-r from-qcyan to-qcyan-soft"
                style={{ width: `${p.progress}%` }}
              />
            </div>
            <p className="text-xs text-muted-foreground mt-2">{p.progress}% complete</p>
          </GlassCard>
        </Reveal>
      ))}
    </div>
  );
};

export default Projects;
